module.exports = __webpack_public_path__ + "static/fonts/LavaPro-Reg.ba173c5.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/LavaPro-Reg.eot
// module id = a9Mq
// module chunks = 0